import React from 'react';
import PropTypes from 'prop-types';
import {
    getWordIndex,
    getSkippedRowClassName,
    notIncludedInScore,
} from '../../../utils/shared/probeDetailUtils';
import { generateReactKey } from '../../../utils/shared/commonUtils';
import { FslBoxPropType } from '../espanol/fsl/propTypes';

const AssessmentRow = props => {
    const {
        line,
        lineIndex,
        isRowSkipped,
        selfCorrectedItems,
        incorrectItems,
        lastSelectedItem,
        selfCorrectedMark,
        RowCell,
    } = props;
    return (
        <div className="row assessment-row" data-tour-allow-interaction>
            <div className={`col-12 ${getSkippedRowClassName(isRowSkipped)}`}>
                {line.map((word, index) => {
                    const wordIndex = getWordIndex(lineIndex, index, line.length);
                    return (
                        <RowCell
                            key={generateReactKey(lineIndex, index)}
                            word={word}
                            isLastSelected={lastSelectedItem === wordIndex}
                            isSelfCorrected={selfCorrectedItems.includes(wordIndex)}
                            isIncorrect={incorrectItems.includes(wordIndex)}
                            isHidden={notIncludedInScore(wordIndex, lastSelectedItem)}
                            selfCorrectedMark={selfCorrectedMark}
                        />
                    );
                })}
            </div>
        </div>
    );
};

AssessmentRow.defaultProps = {
    isRowSkipped: false,
    selfCorrectedItems: [],
    incorrectItems: [],
    lastSelectedItem: null,
    selfCorrectedMark: 'sc',
};

AssessmentRow.propTypes = {
    line: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, FslBoxPropType])).isRequired,
    lineIndex: PropTypes.number.isRequired,
    isRowSkipped: PropTypes.bool,
    selfCorrectedItems: PropTypes.arrayOf(PropTypes.number),
    incorrectItems: PropTypes.arrayOf(PropTypes.number),
    lastSelectedItem: PropTypes.number,
    selfCorrectedMark: PropTypes.string,
    RowCell: PropTypes.elementType.isRequired,
};

export default AssessmentRow;
